const Footer = () => (
  <footer className="footer">
    <div className="content size-3 has-text-centered">
      <p className="title is-4 has-text-centered has-text-white">
        <strong>©</strong> Nathan Harris & Ulas Temel 2022
      </p>
    </div>
  </footer>
);

export default Footer;
